import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/teampool/error/teampool-error.svg")